<template>
	<div class="vu-upload-file" v-loading="uploadLoading">
		<el-upload
			ref="uploadRef"
		    class="upload"
		    drag
			:headers="headers"
			v-model:file-list="fileList"
		    :action="`${apiPrefix}${uploadUrl}`"
			:limit="limit"
		    :multiple="multiple"
			:data="extraData"
			:accept="accept"
			:http-request="httpRequest"
			:before-upload="handleBeforeUpload"
			:on-preview="handlePictureCardPreview"
			:on-success="handleImageSuccess"
			:on-remove="handleImageRemove"
			:on-progress="handleImageUploading"
			:show-file-list="showFileList">
		    <el-icon class="el-icon--upload"><upload-filled /></el-icon>
		    <div class="el-upload__text">
		      拖拽文件到此处 或者 <em>点击上传</em>
		    </div>
		    <template #tip>
		      <div class="el-upload__tip d-flex d-flex-align-items-center">
				<slot name="tips">{{tips}}</slot>
		      </div>
		    </template>
		</el-upload>
	</div>
</template>

<script setup>
	import { useMessage } from '@/utils/message'
	import { post } from '@/utils/request'
	import { useStorage } from '@/utils/storage'
	
	const uploadRef = ref(null)
	const uploadLoading = ref(false)
	
	const props = defineProps({
		modelValue: { type: Array, default: () => ([]) },
		uploadUrl: { type: String, required: true },
		headers: { type: Object, default: ()=>({}) },
		accept: { type: String },
		tips: { type: String },
		limit: { type: Number },
		extraData: { type: Object, default:()=>({}) },
		multiple: { type: Boolean, default: false },
		showFileList: { type: Boolean, default: false },
		onBeforeUpload: { type: Function },
		onSuccess: { type: Function },
		onUploading: { type: Function },
		onRemove: { type: Function },
		httpRequest: { type: Function }
	})
	
	const emits = defineEmits(['update:modelValue'])
	
	const apiPrefix = import.meta.env.VITE_APP_API_BASE;
	
	const { modelValue, headers, onSuccess, onBeforeUpload, onUploading, httpRequest, onRemove } = toRefs(props)
	
	const token = useStorage('local').get('user-token')
	if(token && !headers.value['TOKEN']) {
		headers.value['TOKEN'] = token
	}
	
	const fileList = ref([])
	
	const handlePictureCardPreview = (file) => {
		useMessage('show').show()
	}
	
	const handleBeforeUpload = (file, files) => {
		//uploadLoading.value = true
		onBeforeUpload.value && onBeforeUpload.value.call(this, file, files)
	}
	
	const handleImageUploading = (e, file, files) => {
		onUploading.value && onUploading.value.call(this, e, file, files)
	}
	
	const handleImageSuccess = (res, file, files) => {
		//uploadLoading.value = false 
		const { uid, name, size, raw } = file
		
		// 合并
		const dataList = [...modelValue.value]
		
		if(httpRequest.value) {
			dataList.push({ id:0, uid, name, size, mime: raw.type, url: res.url, objectId: res.objectId })
		}
		else {
			if(res.code != 0) {
				useMessage('上传失败').show('error')
				return 
			} 
			
			useMessage('上传成功').show('success')
			
			
			// 当前文件的成功数据
			const { data } = res
			const updatedFile = { id: data.id, uid, name, size, mime: raw.type, url: data.url, objectId: data.objectId }
			dataList.push(updatedFile)
		}
		
		emits('update:modelValue', dataList)
		
		onSuccess.value && onSuccess.value.call(this, file, files, dataList) 
	}
	
	const handleImageRemove = async (file, files) => {
		try{
			await useMessage('是否确定删除？').confirm()
			
			const dataList = props.modelValue.filter(item => item.url !== file.url)
			
			onRemove.value && onRemove.value.call(this, file, files, dataList)
			emits('update:modelValue', dataList)
		}
		catch(err) {}
	}
	
	onMounted(() => {
		fileList.value = modelValue.value.map(item => ({
			id: item.id,
			name: item.name,
			url: item.url,
			status: 'success'
		}))
	})
</script>

<style lang="scss" scoped>
	.vu-upload-file {
		width: 100%;
		
		.upload {
			
		}
	}
</style>